// Module
var code = "<chart-overview-directive report-base-url=\"adminOverviewCharts.reportBaseUrl\" auth-token=\"adminOverviewCharts.authToken\" country-locale=\"adminOverviewCharts.countryLocale\"> </chart-overview-directive> ";
// Exports
module.exports = code;